import { Box } from "@mui/material";

interface ICustomTabProps {
    children: React.ReactNode;
    index: number;
    value: number;
}

const CustomTabContent = ({ children, index, value, ...otherProps }: ICustomTabProps) => {
    return (
        <Box role="customPanel" hidden={value !== index} id={`customPanel-${index}`} {...otherProps}>
            {value === index && <Box>{children}</Box>}
        </Box>
    );
};

export default CustomTabContent;
